module.exports = __webpack_public_path__ + "img/icons-zhpj-dypj.bb81d6b8.png";